import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { GreenLeafWithOverKGReportSchemaObject } from '../GreenLeafWithOverKGReportSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _, { isNumber } from 'lodash';
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const screenCode = "GREENLEAFREPORTWITHOVERKG";
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function GreenLeafReportListing(props) {

    const classes = useStyles();
    const componentRef = useRef();
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [gang, setGang] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [totalRow, setTotalRow] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [dateList, setDateList] = useState([]);
    const [finalTotalVal, setFinalTotalVal] = useState([]);
    const [finalTotalOverkiloVal, setFinalTotalOverkiloVal] = useState([]);

    const [greenLeafSummaryDetails, setGreenLeafSummaryDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        month: "",
        gangID: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        operationEntity: "",
        collectionPoint: "",
        month: "",
        gang: ""
    });

    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);

    const schema = Joi.object(GreenLeafWithOverKGReportSchemaObject).options({ allowUnknown: true });
    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [greenLeafSummaryDetails.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown()
        )
    }, [greenLeafSummaryDetails.estateID])

    useEffect(() => {
    }, [reportData]);

    useEffect(() => {
        trackPromise(
            getGangByCollectionPointID()
        )
    }, [greenLeafSummaryDetails.divisionID])

    function handleGroupChange(target) {
        validateInputs(target);

        setGreenLeafSummaryDetails({
            ...greenLeafSummaryDetails,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);
        setGreenLeafSummaryDetails({
            ...greenLeafSummaryDetails,
            estateID: target.value,
            divisionID: "0"
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);
        setGreenLeafSummaryDetails({
            ...greenLeafSummaryDetails,
            divisionID: target.value,

        });
    }

    function handleGangChange(target) {
        setGreenLeafSummaryDetails({
            ...greenLeafSummaryDetails,
            gangID: target.value,

        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);
        setGreenLeafSummaryDetails({
            ...greenLeafSummaryDetails,
            month: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, GreenLeafWithOverKGReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];
        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGREENLEAFREPORTWITHOVERKG');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setGreenLeafSummaryDetails({
            ...greenLeafSummaryDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(greenLeafSummaryDetails.groupID);
        setEstates(data);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(greenLeafSummaryDetails.estateID);
        setDivisions(data);
    }

    async function getGangByCollectionPointID() {
        const gang = await services.getGangByCollectionPointID(greenLeafSummaryDetails.estateID, greenLeafSummaryDetails.divisionID);
        setGang(gang);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {
        e.preventDefault();
        const errorMessages = validate(schema, greenLeafSummaryDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        const results = await services.getgreenLeafReportData(greenLeafSummaryDetails);
        getSelectedDropdownValuesForReport(greenLeafSummaryDetails);
        formatResult(results);
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setGreenLeafSummaryDetails({
            ...greenLeafSummaryDetails,
            searchDate: ""
        });
        setIsTableHide(true);
        setErrors("");
        setIsReportButtonsEnabled(false);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: estates[searchForm.estateID],
            collectionPoint: divisions[searchForm.divisionID],
            month: searchForm.month,
            gang: gang[searchForm.gangID]
        })
    }

    function getNumDaysInMonth(dateStr) {
        const [year, month] = dateStr.split('-');
        const date = new Date(year, month, 0);
        return date.getDate();
    }

    function formatResult(data) {
        const numDaysInMonth = getNumDaysInMonth(greenLeafSummaryDetails.month);
        let dateArray = [];
        for (let i = 1; i <= numDaysInMonth; i++) {
            if (i < 10) {
                dateArray.push('0' + i);
            }
            else { dateArray.push(i); }
        }

        let newData = [];
        newData = [...data];

        newData.forEach(x => {
            x.list.forEach(y => {
                y.date = y.cardReadTime.slice(8, 10);
            })
        })

        newData.sort((a, b) => (a.registrationNumber) - (b.registrationNumber));

        let total = [];
        let finalTotalOverKilo = 0;
        let finalTotal = 0;
        data.forEach(obj => {
            obj.list.forEach(item => {
                var sameDate = total.find(x => x.name == item.date)
                if (sameDate) {
                    sameDate.value = sameDate.value + item.totalAmount;
                    if (item.totalAmount > item.configurationValue) {
                        sameDate.totalOverKilo = sameDate.totalOverKilo + (item.totalAmount - item.configurationValue);
                    }
                }
                else {
                    total.push({
                        name: item.date,
                        value: item.totalAmount,
                        totalOverKilo: (item.totalAmount > item.configurationValue) ? (item.totalAmount - item.configurationValue) : 0
                    })
                }
            });
        });
        total.forEach(x => {
            finalTotal += x.value
            finalTotalOverKilo += x.totalOverKilo
        });
        setTotalRow(total);
        setFinalTotalOverkiloVal(finalTotalOverKilo);
        setFinalTotalVal(finalTotal);
        setDateList(dateArray);
        setTableData(newData);
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Green Leaf Report With Over KG Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={greenLeafSummaryDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={greenLeafSummaryDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={greenLeafSummaryDetails.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="">Gang *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="gangID"
                                            id="gangID"
                                            name="gangID"
                                            value={greenLeafSummaryDetails.gangID}
                                            onChange={(e) => handleGangChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Gang--</MenuItem>
                                            {generateDropDownMenu(gang)}
                                        </Select>
                                        {errors["gangID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["gangID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="date">Month *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="month"
                                            name="date"
                                            type="month"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["date"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            {tableData.length != 0 ?
                                <Container>
                                    <Card style={{ justifycontent: 'center' }}>
                                        <Paper className={classes.paper}>
                                            <TableContainer>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow style={{ border: "2px solid black" }}>
                                                            <TableCell align="center" rowSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>EMP No</TableCell>
                                                            {dateList.map(x => {
                                                                return (
                                                                    <TableCell key={x} colSpan={2} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{x}</TableCell>
                                                                )
                                                            })}
                                                            <TableCell align="center" colSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>Total</TableCell>
                                                        </TableRow>
                                                        <TableRow style={{ border: "2px solid black" }}>
                                                            {dateList.map(x => {
                                                                return (
                                                                    <>
                                                                        <TableCell key={x} align="center" style={{ border: "2px solid black", fontWeight: "bold", fontSize: '11px' }}>Kilos (Kg)</TableCell>
                                                                        <TableCell key={x} align="center" style={{ border: "2px solid black", fontWeight: "bold", fontSize: '11px' }}>Over Kilos (Kg)</TableCell>
                                                                    </>
                                                                )
                                                            })}
                                                            <TableCell key={x} align="center" style={{ border: "2px solid black", fontWeight: "bold", fontSize: '11px' }}>Total Kilos (Kg)</TableCell>
                                                            <TableCell key={x} align="center" style={{ border: "2px solid black", fontWeight: "bold", fontSize: '11px' }}>Total Over Kilos (Kg)</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {tableData.map(item => {
                                                            let totalKillo = 0;
                                                            let totalOverKilo = 0;
                                                            return (
                                                                <TableRow style={{ border: "2px solid black" }} key={item.date}>
                                                                    <TableCell key={item.registrationNumber} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.registrationNumber}</TableCell>
                                                                    {dateList.map(x => {
                                                                        const res = item.list.filter(y => parseInt(y.cardReadTime.slice(8, 10)) == parseInt(x))
                                                                        if (res.length > 0) {
                                                                            totalKillo += res[0].totalAmount;
                                                                            if (res[0].totalAmount > res[0].configurationValue) {
                                                                                totalOverKilo = totalOverKilo + (res[0].totalAmount - res[0].configurationValue);
                                                                            }
                                                                        }
                                                                        return (
                                                                            <>
                                                                                {res.length > 0 ?
                                                                                    <>
                                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.registrationNumber}>{res == undefined ? "-" : res[0].totalAmount}</TableCell>
                                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.registrationNumber}>{res == undefined ? "-" :
                                                                                            (res[0].totalAmount > res[0].configurationValue ?
                                                                                                (res[0].totalAmount - res[0].configurationValue) : 0)}</TableCell>
                                                                                    </> :
                                                                                    <>
                                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.registrationNumber}>{"-"}</TableCell>
                                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.registrationNumber}>{"-"}</TableCell>
                                                                                    </>
                                                                                }
                                                                            </>
                                                                        )
                                                                    })}
                                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{parseFloat(totalKillo)}</TableCell>
                                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{parseFloat(totalOverKilo)}</TableCell>
                                                                </TableRow >
                                                            )
                                                        })}
                                                        <TableRow style={{ border: "2px solid black" }}>
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} >Total</TableCell>
                                                            {dateList.map(date => {
                                                                const value = totalRow.find(x => x.name == date)
                                                                return (
                                                                    <>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={`vertical-${date}`}>
                                                                            {value == undefined ? '-' : value.value}
                                                                        </TableCell>
                                                                        <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={`vertical-${date}`}>
                                                                            {value == undefined ? '-' : value.totalOverKilo}
                                                                        </TableCell>
                                                                    </>
                                                                )
                                                            })}
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} > {finalTotalVal}</TableCell>
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} > {finalTotalOverkiloVal}</TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Paper>
                                    </Card>
                                </Container>
                                : null}
                            {tableData.length > 0 ?
                                <div className="pt-2" style={{ paddingRight: "8%" }}>
                                    <ReactToPrint
                                        documentTitle={"Green Leaf Report With Over KG Report"}
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="PDF"
                                        />}
                                        content={() => componentRef.current}
                                    />
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef}
                                            searchData={selectedSearchValues}
                                            dateList={dateList}
                                            data={tableData}
                                            totalRow={totalRow}
                                            finalTotalVal={finalTotalVal}
                                            finalTotalOverkiloVal={finalTotalOverkiloVal} />
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div >
        </Fragment >
    );
}
